import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";
import router from "@/router";


Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    isAuthenticated: false,
    isLoading: false,
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
    setIsAuthenticated(state, payload) {
      state.isAuthenticated = payload;
    },
    setIsLoading(state, payload) {
      state.isLoading = payload;
    },
  },
  getters: {
    user : state => {
      return state.user;
    }
  },
  actions: {
    userLogin({ commit }, { email, password }) {
      firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then(user => {
          commit("setUser", user);
          commit("setIsAuthenticated", true);
          user.user?.getIdToken().then(token => console.log(token));
          router.push("/about");
        })
        .catch(() => {
          commit("setUser", null);
          commit("setIsAuthenticated", false);
          router.push("/");
        });
    },
    userJoin({ commit }, { email, password }) {
      firebase
        .auth()
        .createUserWithEmailAndPassword(email, password)
        .then(user => {
          commit("setUser", user);
          commit("setIsAuthenticated", true);
          router.push("/");
        })
        .catch(() => {
          commit("setUser", null);
          commit("setIsAuthenticated", false);
          router.push("/signin");
        });
    },
    userSignOut({ commit }) {
      firebase
        .auth()
        .signOut()
        .then(() => {
          commit("setUser", null);
          commit("setIsAuthenticated", false);
          router.push("/");
        })
        .catch(() => {
          commit("setUser", null);
          commit("setIsAuthenticated", false);
          router.push("/");
        });
    },
    reloadUser({ commit }) {
      commit("setIsLoading", true);
      firebase.auth().onAuthStateChanged(
        (user) => {
          commit("setIsLoading", false);
          if (user != null) {
            commit("setUser", user);
            commit("setIsAuthenticated", true);
            router.push("/status");
          } else {
            console.log("not authenticated")
            router.push("/signin");
          }
        }
        
    );
      
    },
  },
  modules: {}
});
